/**
 * Détection de l'hôte de production TAMA.
 *
 * Pourquoi : la clé Google reCAPTCHA est liée au domaine de production.
 * Les previews Lovable (*.lovable.app, id-preview--*) et localhost ne sont
 * pas déclarés dans la console Google ; y monter le widget provoque
 * « Domaine non valide pour la clé de site ». Le reCAPTCHA n'est donc
 * exigé que sur l'hôte de production.
 */
const PRODUCTION_HOSTS = ["tama-nesian.life", "www.tama-nesian.life"];

export function isProductionApp(): boolean {
  if (typeof window === "undefined") return false;
  return PRODUCTION_HOSTS.includes(window.location.hostname);
}
